export const ALLOWED_MIME_TYPES = [
  "application/msword", // DOC
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
  "text/csv", // CSV
  "application/vnd.ms-excel", // XLS
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
  "application/vnd.ms-powerpoint", // PPT
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PPTX
  "application/pdf", // PDF
  "text/plain", // TXT
  "image/jpeg", // JPEG/JPG
  "image/gif", // GIF
  "image/bmp", // BMP
  "image/png", // PNG
  "video/mp4", // MP4
];

export const ALLOWED_EXTENSIONS = [
  ".png",
  ".doc",
  ".docx",
  ".csv",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".pdf",
  ".txt",
  ".jpeg",
  ".jpg",
  ".gif",
  ".bmp",
  ".mp4",
];
